import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const commissionApi = createApi({
  reducerPath: "commissionApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "financial/commission/policies",
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.userSlice?.token;
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAllCommissions: builder.query({
      query: () => {
        return {
          url: "/",
          method: "GET",
        };
      },
    }),
  }),
});

export const { useGetAllCommissionsQuery } = commissionApi;
